import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { MoveListService } from '@scaffold/services/move-list.service';
import { ItemsService } from '@scaffold/services/items.service';
import { Subscription } from 'rxjs';
import cloneDeep from 'lodash/cloneDeep';
import { CommentingService } from '../../services/commenting.service';
import { ScaffoldDialogService } from "@app/framework/dialog/scaffold-dialog.service";
import { ScaffoldSidebarService } from '@app/framework/sidebar/scaffold-sidebar.service';
import { CommentSidebarComponent } from '@app/commenting/comment-sidebar/comment-sidebar.component';
import { RenderedService } from './rendered.service';
import { IframeService } from '@services/iframe.service';
import { EnvironmentService, InstanceDetails } from '@services/environment.service';

@Component({
  selector: 'app-rendered',
  templateUrl: './rendered.component.html',
  styleUrls: ['./rendered.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RenderedComponent implements OnInit, OnDestroy {
  instanceDetails: InstanceDetails;
  isHidden: Boolean;
  @Input() view: any[];
  @Input() childview;
  private _item;
  commentSubscription;
  commentUpdatesub;
  comments = {};
  @Input('item')
  set item (val) {
    this._item = val;
    this.init();
    //  console.log("ITEM CHANGE " + this._item.type);
  }
  get item () {
    return this._item;
  }
  @Input() paramprefix = '';
  @Input() data;
  _info;
  @Input('info')
  set info (inf) {
    this._info = inf;
    this.init();
  }
  get info () {
    return this._info;
  }
  _indexActive;
  @Input('indexActive')
  set indexActive (value) {
    this._indexActive = value;
  }
  rootItem;
  integrations = [];
  currentRoute;
  active = true;
  data_data = {};
  updateSent = false;
  created = false;
  changeDetection: Subscription;

  active_comments;
  comments_allowed = ['input', 'select', 'checkbox', 'switch', 'edit_text', 'connection', 'editor', 'radio'];
  //   editor_options;
  //   isEditorActive = false;
  //   editorExtendedHelp = "<p>Test</p>"
  //   inline_data;
  originalItems;
  cloneDeep = cloneDeep;
  updateSubscription;
  resetSubsription;

  constructor (
    public iframeService: IframeService,
    private cdr: ChangeDetectorRef,
    public dialog: ScaffoldDialogService,
    private courseService: CourseService,
    private moveList: MoveListService,
    private itemsService: ItemsService,
    private renderedService: RenderedService,
    private commentor: CommentingService,
    private commentSidebar: ScaffoldSidebarService,
    private environmentService: EnvironmentService) { }


  init () {
    if (this.item && this.info) {
      if (this.info.id) {
        this.environmentService.getInstanceDetails().subscribe(det => {
          this.instanceDetails = det;
          this.checkComments()
        });
        // this.courseService.setTitle(this.info.id, this.info.title);
      }
      //  console.log(this.data)
      if (this.item.type !== 'data_array') {

        if (this.item.name) {
          const curValue = this.getValue(this.data, this.item.name);
          if (curValue) {
            this.item.value = cloneDeep(curValue);
            this.detectChanges();
            this.originalItems = cloneDeep(this.item.value);
          }
          this.originalItems = cloneDeep(this.item.value);

          this.item.value = this.getUpdatedValue(this.item.name, this.info) || this.item.value;
        }
      }
      this.forceRequiredCheck();
      if (this.updateSubscription && this.updateSubscription.unsubscribe) {
        this.updateSubscription.unsubscribe();
      }
      this.updateSubscription = null;
      this.setItem();

    }
  }

  checkComments () {
    if (this.allowComments()) {
      console.log("ALLOW COMMENTS");
      this.comments = this.item._comments || this.item.comments || [];
      console.log('COMMENTS:', this.comments);
      this.commentSubscription = this.commentor.getCommentsUpdates().subscribe(comments => {
        if (comments[this.info.id] && comments[this.info.id][this.item.name]) {
          this.comments = comments[this.info.id];
          this.detectChanges();
        }
      });
      this.commentUpdatesub = this.commentor.watchActive().subscribe(i => {
        this.detectChanges();
      });
    }
  }

  sendUpdate (key, value, info, error?) {
    // if (this.isInModal())
    // console.log("In modal");
    this.updateSent = true;
    // Process items with dot notation in the name to get referenced child to allow updating and displaying data
    if (key) {
      if (key.match(/\./)) {
        const key_base = key.split(/\./)[0];
        if (this.info.related && this.info.related[key_base]) {
          info = { id: this.info.related[key_base], type: key_base };
          key = key.split(/\./)[1];
        }
      }
      if (this.item.required && (value === undefined || value === null)) {
        error = 'required';
      }
      let prefix = '';
      if (this.paramprefix) {
        prefix = this.paramprefix + (this.paramprefix.length > 0 ? '/' : '');
      }
      console.log('updating ' + prefix + key, value);
      console.log(info);
      this.itemsService.updateValue(prefix + key, value, info, error);
    }
  }
  getUpdatedValue (key, info): any {
    // Process items with dot notation in the name to get referenced child to allow updating and displaying data

    if (key.match(/\./)) {
      const key_base = key.split(/\./)[0];
      if (this.info.related && this.info.related[key_base]) {
        info = { id: this.info.related[key_base], type: key_base };
        key = key.split(/\./)[1];
      }
    }
    let prefix = '';
    if (this.paramprefix) {
      prefix = this.paramprefix + (this.paramprefix.length > 0 ? '/' : '');
    }
    let value;
    value = this.itemsService.getValue(prefix + key, info);

    return value;
  }

  setItem () {
    if (this.info && this.item && this.item.name && !this.updateSubscription) {
      // Process items with dot notation in the name to get refrenced child to allow updating and displaying data
      let info = this.info, name = this.item.name;
      if (this.item.name && this.item.name.match(/\./) && this.info.related) {
        const key_base = this.item.name.split(/\./)[0];
        if (this.info.related[key_base]) {
          info = { id: this.info.related[key_base], type: key_base };
          name = this.item.name.split(/\./)[1];
        }
      }
      // This subscription handles all data updates, the data models are also stored in this service

      if (this.item.name.match(/\./)) {
        const key_base = this.item.name.split(/\./)[0];
        if (this.info.related && this.info.related[key_base]) {
          const rinfo = { id: this.info.related[key_base], type: key_base };
          const key = this.item.name.split(/\./)[1];
          //  console.log(this.item.type, rinfo);
          this.updateSubscription = this.itemsService.registerItem(rinfo).subscribe(d => {
            console.log(d);
            if (d.hasOwnProperty(key)) {
              console.log('updating ' + this.item.name + ' to ' + d[this.item.name], ':' + this.item.type + ' - ' + this.item.name);
              try {
                const val = this.getValue(d, key);
                this.item.value = cloneDeep(val);

              } catch (e) {
                console.log(e);
              }
              if (this.item && this.item.integration_type) {
                let selectedIntegrations = [];
                if (this.item.value) {
                  selectedIntegrations = this.item.value.split('|');
                }
                this.integrations.forEach(integration => {
                  integration.selected = selectedIntegrations.includes(integration.name);
                });
              }
              this.detectChanges();
              this.updateSent = false;
            }
          });
        }

      } else {
        this.updateSubscription = this.itemsService.registerItem(info).subscribe(d => {

          let key: string = name;
          if (this.paramprefix && this.paramprefix.length > 0) {
            key = this.paramprefix + '/' + key;
          }
          if (this.item.type == 'conditional') {
            console.log(key);
          }
          // check for update on data_array
          /* if (key.match(/\//))
             key = key.split(/\//)[0];*/
          if (this.itemsService.hasKey(d, key)) {
            // console.log(d)
            //  console.log("updating " + name + " to " + this.getValue(d, name), ":" + this.item.type);
            try {
              const val = this.getValue(d, name);
              this.item.value = cloneDeep(val);

            } catch (e) {
              console.log(e);
            }
            if (this.item && this.item.integration_type) {
              let selectedIntegrations = [];
              if (this.item.value) {
                selectedIntegrations = this.item.value.split('|');
              }
              this.integrations.forEach(integration => {
                integration.selected = selectedIntegrations.includes(integration.name);
              });
            }
            this.detectChanges();
            this.updateSent = false;
          }
        });
      }
    }
  }


  getValue (data, key) {
    let prefix = '';
    if (this.paramprefix) {
      prefix = this.paramprefix + (this.paramprefix.length > 0 ? '/' : '');
    }
    return this.itemsService.get(data, prefix + key);
  }

  getCommentCount (name) {
    let toReturn = 0;
    if (this.comments && this.comments[name]) {
      if (this.comments[name].length === 0) {
        return 0;
      }
      //  console.log(this.comments[name]);
      const not_resolved = [];
      this.comments[name].forEach(com => {
        if (!com.resolved) {
          not_resolved.push(com.id);
        }
      });
      const unresolved = this.comments[name]
        .filter(com => !com.resolved && (!com.response_to || not_resolved.includes(com.response_to)))
        .filter(com => {
          if (this.info.claimed_comments && this.item.type === 'editor') {
            return !this.info.claimed_comments.includes(com.id.toString()) && (!com.response_to || !this.info.claimed_comments.includes(com.response_to.toString()));
          } else {
            return true;
          }
        });
      toReturn = unresolved.length;
      console.log(toReturn);
    }

    return toReturn;

  }

  validate (e) {
    console.log(e);
  }


  openLink (mode: any) {
    console.log(mode);
    // this.openLinkHandler(mode, this.info);
  }



  forceRequiredCheck () {
    // console.log("checking required")
    if (this.item.required) {
      console.log('item required', this.item.name);
      //   console.log(this.item.value, this.data.hasOwnProperty(this.item.name))
      if ((this.item.value == undefined || this.item.value == null) && !this.getValue(this.data, this.item.name)) {
        console.log('sending required error', this.item.type, this.item.name, this.info.id);
        this.item.notvalid = true;
        this.sendUpdate(this.item.name, this.item.value, this.info, 'required');
        // this.itemsService.updateValue(this.item.name, this.item.value, this.info, "required");
      }
    }
  }

  update (data, eventKey?) {
    console.log('update', data);
    // !data.target is temp fix for using change on component in html triggering the event without A value
    if (data) {
      if (!data.target) {
        let value = data[eventKey || 'value'];
        let key = data.key;
        if (!key) {
          key = this.item.name;
        }
        if (this.item?.no_html) {
          value = value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }

        if (value !== this.getValue(this.data, key) || data.error) {
          this.sendUpdate(key, value, this.info, data.error);
        }
      }
    }
  }

  updateFromElement (data, eventKey?) {
    let error;
    // console.log(data)
    let value = data.target.value;
    if (data.target.validity.valid == false) {
      error = this.item.invalid || data.target.validationMessage;
      this.item.notvalid = true;
    } else {
      this.item.notvalid = false;
    }
    this.detectChanges();
    if (this.item?.input_type == 'number') {
      value = parseInt(value);
      if (error) {
        if (data.target.validity.rangeOverflow) {
          this.item.value = data.target.max;
          value = data.target.max;
          error = undefined;
        }
        if (data.target.validity.rangeUnderflow) {
          this.item.value = data.target.min;
          value = data.target.min;
          error = undefined;
        }
      }
    }
    // console.log(value, eventKey || 'value');
    this.sendUpdate(this.item.name, value, this.info, error);
  }


  ngOnDestroy () {
    if (this.changeDetection) {
      this.changeDetection.unsubscribe();
    }
    if (this.commentUpdatesub) {
      this.commentUpdatesub.unsubscribe();
    }
    this.active = false;
    if (this.updateSubscription) {
      this.updateSubscription.unsubscribe();
    }
    if (this.resetSubsription) {
      this.resetSubsription.unsubscribe();
    }
    if (this.item.type != 'editor') {
      delete this.item.view;
    }
    this.cdr.detach();
  }


  ngOnInit () {

    this.item.paramprefix = this.paramprefix;
    // Set the index of the item based on it's position in the list, if the item name is 'item.index'

    this.changeDetection = this.renderedService.listenForUpdates().subscribe(e => {
      this.detectChanges();
    });

    if (this.item.hasOwnProperty('default')) {
      // console.log("Has Default", this.item)
      if (!this.item.hasOwnProperty('value') || this.item.value === undefined || this.item.value === null) {
        //  console.log(this.item.default);
        setTimeout(t => {
          if (this.item.default === 'true') {
            this.item.default = true;
          }
          if (this.item.default === 'false') {
            this.item.default = false;
          }
          this.item.value = this.item.default;
          this.sendUpdate(this.item.name || this.item.setting, this.item.default, this.info);
        });
      }
    }

    this.moveList.cancelMove();
    if (!this.data) {
      this.data = {};
    }


    if (this.childview && this.childview.length > 0) {
      this.view = this.childview;
    } else {
      if (this.item && this.item.list_view && this.item.list_view.length > 0 && !this.view && this.item.type !== 'list_card' && this.item.type !== 'list_index') {

        // I think we need this block for a data table?

        // Grab the types for this list, will need to pass to back end for sorting.
        if (!this.item.hasOwnProperty('list_content')) {
          //        console.log("GET LIST")
        } else {
          if (this.item.list_content.listItems) {
            this.view = this.item.list_content.listItems;
          } else {
            this.view = [this.item.list_content];
          }
          // this.triggerUpdate("loaded")
          this.detectChanges();
        }

      }
    }

    if (!this.resetSubsription) {
      this.resetSubsription = this.itemsService.registerReset().subscribe(r => {
        this.updateSent = false;

        if (r === 'reset') {
          this.item.value = cloneDeep(this.originalItems);
        } else if (r === 'saved') {
          this.originalItems = cloneDeep(this.item.value);
        }
        this.detectChanges();

      });
    }
    this.isHidden = false;
  }






  allowComments () {
    return !!(
      this.item.name && this.item.allow_comments
      && (this.comments_allowed.includes(this.item.type) || this.item.allow_comments)
      && this.instanceDetails?.scaffoldType === 'designer'
    );
  }

  getCommentClass (key?) {
    let toreturn;
    const noComments = 'far fa-comment';
    const oneComment = 'fas fa-comment';
    const multipleComments = 'fas fa-comments';

    if (this.getCommentCount(this.item.name) > 0) {
      if (this.comments[this.item.name].length === 1) {
        toreturn = oneComment;

      } else {
        toreturn = multipleComments;
      }
    } else {
      toreturn = noComments;
    }
    if (key) {
      const parts = toreturn.split(/\s/);
      const obj = {
        pack: parts[0],
        icon: parts[1].replace(/fa-/, '')
      };
      return obj[key];
    }
    console.log(toreturn);
    return toreturn;
  }

  setActiveComments (e: Event) {
    // e.stopPropagation();
    e.preventDefault();
    const selection = this.getSelectionText();
    console.log(selection);
    /* if (this.item.name)
       this.comments = this.commentor.getCommentHolder(this.info);*/
    console.log(this.comments);
    console.log(this.info);
    let config: any;
    if (this.comments && this.comments.hasOwnProperty(this.item.name) && this.item.type === 'editor') {
      const filter: Array<any> = this.comments[this.item.name]
        .filter(com => {
          if (this.info.claimed_comments) {
            console.log(com.id, this.info.claimed_comments.includes(com.id.toString()), com.response_to && this.info.claimed_comments.includes(com.response_to.toString()));
            let found = true;
            if (this.info.claimed_comments.includes(com.id.toString())) {
              found = false;
            }
            if (com.response_to && this.info.claimed_comments.includes(com.response_to.toString())) {
              found = false;
            }
            return found;
          }
        }).map(com => "" + com.id);
      console.log(filter);
      config = {
        context: {
          item: this.item.name,
          info: this.info,
          label: this.item.label || this.item.name,
          subItem: null,
          details: { filter: filter }
        }
      };
    } else {
      config = {
        context: {
          item: this.item.name,
          info: this.info,
          label: this.item.label || this.item.name
        }
      };
    }
    const _sidebar = this.commentSidebar.open(CommentSidebarComponent, config);
    this.detectChanges();
  }

  isActive () {
    return (this.info === this.commentor.info && this.commentor.active_comments === this.item.name && !this.commentor.item);
  }

  getSelectionText () {
    let text = '';
    if (window.getSelection) {
      text = window.getSelection().toString();

    }
    return text;
  }

  detectChanges () {
    this.cdr.markForCheck();
  }

  triggerUpdate (e?) {
    console.log(e);
    try {
      this.renderedService.triggerUpdate(e);
    } catch (e) {
      //  console.log(e)
    }
  }

}
